import React, { useState, useEffect } from "react";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  UploadOutlined,
  CalendarOutlined,
  MailOutlined,
  PhoneOutlined,
  SaveOutlined,
  SendOutlined,
  FileTextOutlined,
  InfoCircleOutlined,
  StopOutlined,
  CloseCircleOutlined,
  SyncOutlined,
  EyeOutlined,
  DeleteOutlined,
  InboxOutlined,
  PlusOutlined,
  MinusOutlined,
  FileOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import {
  Card,
  Input,
  Select,
  Button,
  Tag,
  Modal,
  Upload,
  Form,
  Tooltip,
  DatePicker,
  Radio,
  Space,
  Row,
  Col,
  Divider,
  Checkbox,
  InputNumber,
  message,
  Result,
  Spin,
  Descriptions,
} from "antd";
import "./index.less";
import { injectIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import {
  Getsubobligationform,
  submitObligationAttachmentdata,
  submitObligationdata,
  validateTokenForFillObligation,
} from "../MyObligation/MyObligation.Action";
import {
  DeleteUrlfromfile,
  ObligationvalueaddedonChange,
  setViewAttachobgDocsdrawerVisible,
} from "../MyObligation/MyObligation.Slice";
import moment from "moment";
import {  fetchObligationInfo, useDateTimeFormatter } from "../../utils/helper";
import newLogo from "../../assets/images/newLogo.png";
import { setobligationRejectmodalVisible } from "../myContracts/myContract.Slice";
import Rejectobligationmodal from "../myContracts/Model/Obligationmodal/Rejectobligationmodal";
import { getAcceptorrejectobligation } from "../myContracts/myContract.Action";
import "../MyObligation/Model/Fillobligation.less";
import ViewAttachobgDocsdrawer from "../MyObligation/Drawer/ViewattchedobligationUrl";
const { TextArea } = Input;
const { Option } = Select;
const { Dragger } = Upload;

const { confirm } = Modal;
const ObligationFormAntd = (props) => {
  const [form] = Form.useForm();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [fileData, setfileData] = useState({});

  const dispatch = useDispatch();
 const dateTimeFormatter = useDateTimeFormatter();

  const {
    intl: { formatMessage },
    Obligation: { isVisible },
    MyObligation: {
      subObligationsformData = {},
      MySubObligationPagination,
      formfillforobligationrecord,
      isAttachmentsubmitting = false,
      isAttachedDocsVisible,
      formfillforobligationtype,
      AttachmentsubmittedData,
      dataForFillObligation = {},
      isValidatingTokenForFillObligation = false,
      issubobligationformLoading = false,
      issubmitObligationdataLoading = false,
    },
    myContract: {
      isobligationrejectmodalVisible = false,
      isacceptorrejectedLoading = false,
      isAcceptorRejectStatus = null,
      isAcceptorRejectSubmitted = false,
    },
  } = props;
  console.log(dataForFillObligation);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    dispatch(
      validateTokenForFillObligation({
        token,
      })
    ).then(() => {
      setShowSuccessModal(false);
    });
  }, []);

  // fetch data on mount
  useEffect(() => {
    if (dataForFillObligation?.subObligationId) {
      dispatch(
        Getsubobligationform({
          subObligationId: dataForFillObligation?.subObligationId,
          companyId: dataForFillObligation?.companyId,
        })
      );
    }
  }, [dataForFillObligation]);

  const Submitobgligationsform = async () => {
    const values = await form.validateFields();
    console.log(AttachmentsubmittedData);
    const data = {
      obligationFields: subObligationsformData?.obligationFields,
      subObligationId: subObligationsformData._id,
      obligationDocumentURL: AttachmentsubmittedData?.url,
      fileType: AttachmentsubmittedData.mimeType,
      fileName: AttachmentsubmittedData.fileName,
      obligationDescription: values?.obligationDescription || "",
    };
    const currentsubobligationpagination = {
      ...MySubObligationPagination,
      parentObligationId: subObligationsformData.parentObligation,
      obligationFor: subObligationsformData.obligationFor,
      taskId: subObligationsformData.taskId,
    };
    dispatch(
      submitObligationdata({ data, currentsubobligationpagination })
    ).then(() => {
      setShowSuccessModal(true);
    });
  };

  const obligationCurrentstatus = [
    { id: 3, name: "Waiting", color: "default", icon: <ClockCircleOutlined /> },
    { id: 4, name: "Active", color: "processing", icon: <SyncOutlined /> },
    { id: 5, name: "Expired", color: "error", icon: <CloseCircleOutlined /> },
    {
      id: 6,
      name: "Completed",
      color: "success",
      icon: <CheckCircleOutlined />,
    },
    {
      id: 7,
      name: "Accepted",
      color: "success",
      icon: <CheckCircleOutlined />,
    },
    { id: 8, name: "Rejected", color: "error", icon: <StopOutlined /> },
    { id: 9, name: "Terminated", color: "#800000", icon: <StopOutlined /> },
  ];

  const getOblighationstatusvalue = (val) => {
    let statusData = obligationCurrentstatus.find((item) => {
      return item.id === val;
    });
    return statusData;
  };
  const checkFileType = (file) => {
    const allowedTypes = ["pdf", "jpg", "jpeg", "png"];
    const fileNameParts = file.name.split(".");
    const fileType = fileNameParts[fileNameParts.length - 1].toLowerCase();

    if (!allowedTypes.includes(fileType)) {
      message.error(`Only PDF, JPG, JPEG, and PNG files are allowed!`);
      return false; // Block the upload
    }

    return true; // Allow the upload
  };
  const onFormValuesChange = () => {
    setIsFormValid(true);
  };
  const selectexpirydata = [
    {
      name: "years",
      value: "1",
    },
    {
      name: "Months",
      value: "2",
    },
    {
      name: "Weeks",
      value: "3",
    },
  ];
  const formItemLayout = {
    labelCol: { xs: 24, sm: 24, md: 24, lg: 24 },
    wrapperCol: { xs: 24, sm: 24, md: 24, lg: 24 },
  };
  const propsforupload = {
    name: "file",
    multiple: false,
    maxCount: 1,
    beforeUpload: (file) => {
      return checkFileType(file); // checkFileType will return true/false
    },
    customRequest: (file) => {
      const data = new FormData();
      data.append(`file`, file.file);

      dispatch(submitObligationAttachmentdata(data))
        .then((item) => {
          if (item?.payload?.STATUS_CODE === 200) {
            setfileData(file.file);
            file.onSuccess();
          } else {
            file.onError();
          }
        })
        .catch((item) => {
          file.onError();
        });
    },
    accept: ".jpg, .jpeg, .png, .pdf",
    onChange(info) {
      const { status } = info.file;
      const data = new FormData();
      data.append(`file`, info.file.originFileObj);

      // dispatch(submitObligationAttachmentdata(data))
      if (status !== "uploading") {
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    progress: {
      strokeColor: {
        "0%": "#108ee9",
        "100%": "#87d068",
      },
      strokeWidth: 3,
      format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
    },
    onDrop(e) {},
    showUploadList: false,
  };
  const getFileIcon = (fileName) => {
    if (!fileName) return <FileOutlined />;

    const extension = fileName.split(".").pop().toLowerCase();

    if (["doc", "docx", "png", "jpg"].includes(extension)) {
      return (
        <FileImageOutlined style={{ fontSize: "40px", color: "#1890ff" }} />
      );
    } else {
      return <FilePdfOutlined style={{ fontSize: "40px", color: "red" }} />;
    }
  };
  const displayFileName = (name) => {
    if (!name) return "";
    if (name.length > 20) {
      const extension = name.split(".").pop();
      const baseName = name.substring(0, name.lastIndexOf("."));
      return `${baseName.substring(0, 30)}...${
        extension ? "." + extension : ""
      }`;
    }
    return name;
  };
  const removeFile = () => {
    setfileData({});
  };

  const ObligationStatusMessage = ({
    isAcceptorRejectStatus,
    isAcceptorRejectSubmitted,
  }) => {
    // Only show if submitted
    if (!isAcceptorRejectSubmitted) return null;

    let title = "Action Already Taken";
    let subTitle = "This obligation has already been processed.";

    if (isAcceptorRejectStatus === 1) {
      title = "Obligation Accepted Successfully";
      subTitle = "The obligation has been accepted.";
    } else if (isAcceptorRejectStatus === 0) {
      title = "Obligation Rejected Successfully";
      subTitle = "The obligation has been rejected.";
    }

    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#f5f5f5",
        }}
      >
        <Card
          style={{
            maxWidth: 500,
            width: "100%",
            borderRadius: 12,
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <Result status="info" title={title} subTitle={subTitle} />
        </Card>
      </div>
    );
  };

  return (
    <div className="obligation-page">
      {
        <>
          <div className="header-bar">
            <div className="header-left">
              <img className="logo-guest" src={newLogo} alt="logo" />

              <div>
                <span className="logo-guest-txt">VerifiableContract</span>
              </div>
            </div>
            <div className="header-right">
              {dataForFillObligation?.message !== "Link expired" &&
                !isValidatingTokenForFillObligation && (
                  <>
                    <ClockCircleOutlined className="expire-icon" />
                    <span className="expire-text">
                      Expires on{" "}
                      {subObligationsformData.obligationExpiry
                        ? new Date(
                            subObligationsformData.obligationExpiry
                          ).toDateString()
                        : "--"}
                    </span>
                  </>
                )}
            </div>
          </div>

          {!showSuccessModal &&
            [
              "Obligation Rejected Action",
              "Obligation Accepted Action",
              "Good to go",
            ].includes(dataForFillObligation?.message) &&
            !issubobligationformLoading && (
              <div className="content">
                <div className="form-container">
                  <div className="left-column">
                    <Card title="Obligation Details">
                      <p>
                        <b>Name:</b> {subObligationsformData.obligationName}
                      </p>
                      <p>
                        <b>ID:</b> {subObligationsformData?.key}
                      </p>
                      <p>
                        <b>Status:</b>{" "}
                        <Tag
                          icon={
                            getOblighationstatusvalue(
                              subObligationsformData.obligationStatus
                            )?.icon
                          }
                          color={
                            getOblighationstatusvalue(
                              subObligationsformData.obligationStatus
                            )?.color
                          }
                        >
                          <span style={{ fontSize: "0.8rem" }}>
                            {
                              getOblighationstatusvalue(
                                subObligationsformData.obligationStatus
                              )?.name
                            }
                          </span>
                        </Tag>
                      </p>
                      <p>
                        <b>{formatMessage({ id: "due_date" })}:</b>{" "}
                        {new Date(
                          subObligationsformData.obligationDueDate
                        ).toDateString()}
                      </p>
                    </Card>

                    <Card title="Obligation Description">
                      <p>{"NA"}</p>
                    </Card>
                  </div>

                  <div className="right-column">
                    <Card title="Submission Details">
                      <Form
                        onValuesChange={onFormValuesChange}
                        disabled={
                          formfillforobligationrecord?.obligationStatus === 6
                            ? true
                            : ["Obligation Accepted Action"].includes(
                                dataForFillObligation?.message
                              )
                            ? true
                            : false
                        }
                        className="fillobgform"
                        form={form}
                        colon={false}
                        name="register"
                        layout="horizontal"
                        labelWrap
                        scrollToFirstError
                        labelAlign="left"
                        // initialValues={subObligationsformData}
                      >
                        {subObligationsformData?.obligationFields?.map(
                          (field, fieldindex) => (
                            <div key={fieldindex}>
                              <Row key={fieldindex}>
                                <Col span={22}>
                                  {console.log(
                                    "field",
                                    field.value && field.value
                                  )}
                                  <Form.Item
                                    label={
                                      <span
                                        className="activityassets"
                                        title={field.label}
                                      >{`${field.label}`}</span>
                                    }
                                    name={field.label}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    colon={false}
                                    initialValue={
                                      field.value
                                        ? [7].includes(field.dataType)
                                          ? moment(field.value)
                                          : field.value
                                        : undefined
                                    }
                                    hasFeedback
                                    rules={
                                      field.dataType === 8
                                        ? [
                                            {
                                              required: true,
                                              message: formatMessage({
                                                id: "email_rule",
                                              }),
                                            },
                                            {
                                              type: "email",
                                              message: formatMessage({
                                                id: "email_valid_rule",
                                              }),
                                            },
                                          ]
                                        : field.dataType === 9
                                        ? [
                                            {
                                              required: true,
                                              message: `Please enter ${field.label} `,
                                              pattern: new RegExp(/^[0-9]+$/),
                                            },
                                            {
                                              max: 14,
                                              min: 8,
                                              message: (
                                                <span
                                                  style={{
                                                    textTransform: "none",
                                                  }}
                                                >
                                                  {`Phone no must be 8 - 14 digit long`}
                                                </span>
                                              ),
                                            },
                                          ]
                                        : [0, 1].includes(field.dataType)
                                        ? [
                                            {
                                              required: true,

                                              message: `Please Enter ${field.label} `,
                                            },
                                            {
                                              whitespace: true,
                                              message: `Please Enter ${field.label} `,
                                            },
                                          ]
                                        : [
                                            {
                                              required: true,
                                              message: `Please Enter ${field.label} `,
                                            },
                                          ]
                                    }
                                  >
                                    {(field.dataType === 0 && (
                                      <Input
                                        onChange={(e) =>
                                          dispatch(
                                            ObligationvalueaddedonChange({
                                              fieldindex,
                                              value: e.target.value,
                                              field_id: field._id,
                                            })
                                          )
                                        }
                                        placeholder={
                                          field.placeholder ||
                                          `Enter A ${field.label}`
                                        }
                                        size="middle"
                                        width={400}
                                      />
                                    )) ||
                                      (field.dataType === 2 && (
                                        <InputNumber
                                          pattern="^\d+$"
                                          onChange={(e) =>
                                            dispatch(
                                              ObligationvalueaddedonChange({
                                                fieldindex,
                                                value: e,
                                                field_id: field._id,
                                              })
                                            )
                                          }
                                          placeholder={
                                            field.placeholder ||
                                            `Enter A ${field.label}`
                                          }
                                          controls={false}
                                          size="middle"
                                          width={"100%"}
                                          style={{
                                            width: "100%",
                                          }}
                                        />
                                      )) ||
                                      (field.dataType === 14 && (
                                        <TextArea
                                          onChange={(e) =>
                                            dispatch(
                                              ObligationvalueaddedonChange({
                                                fieldindex,
                                                value: e.target.value,
                                                field_id: field._id,
                                              })
                                            )
                                          }
                                          placeholder={
                                            field.placeholder ||
                                            `Enter A ${field.label}`
                                          }
                                          controls={false}
                                          size="middle"
                                          width={"100%"}
                                          style={{
                                            width: "100%",
                                          }}
                                        />
                                      )) ||
                                      (field.dataType === 4 && (
                                        <Upload
                                          onChange={(e) =>
                                            dispatch(
                                              ObligationvalueaddedonChange({
                                                fieldindex,
                                                value: e.file,
                                                field_id: field._id,
                                              })
                                            )
                                          }
                                        >
                                          <Button icon={<UploadOutlined />}>
                                            Click to Upload
                                          </Button>
                                        </Upload>
                                      )) ||
                                      (field.dataType === 1 && (
                                        <TextArea
                                          onChange={(e) =>
                                            dispatch(
                                              ObligationvalueaddedonChange({
                                                fieldindex,
                                                value: e.target.value,
                                                field_id: field._id,
                                              })
                                            )
                                          }
                                          placeholder={
                                            field.placeholder ||
                                            `Enter A ${field.label}`
                                          }
                                          size="small"
                                          width={200}
                                        />
                                      )) ||
                                      (field.dataType === 12 && (
                                        <InputNumber
                                          onChange={(e) =>
                                            dispatch(
                                              ObligationvalueaddedonChange({
                                                fieldindex,
                                                value: e,
                                                field_id: field._id,
                                              })
                                            )
                                          }
                                          placeholder={
                                            field.placeholder ||
                                            `Enter A ${field.label}`
                                          }
                                          controls={false}
                                          size="middle"
                                          width={"100%"}
                                          style={{
                                            width: "100%",
                                          }}
                                        />
                                      )) ||
                                      (field.dataType === 9 && (
                                        <Input
                                          onChange={(e) =>
                                            dispatch(
                                              ObligationvalueaddedonChange({
                                                fieldindex,
                                                value: e.target.value,
                                                field_id: field._id,
                                              })
                                            )
                                          }
                                          // maxLength={10}
                                          // minLength={10}
                                          placeholder={
                                            field.placeholder ||
                                            `Enter A ${field.label}`
                                          }
                                          controls={false}
                                          size="middle"
                                          width={"100%"}
                                          style={{
                                            width: "100%",
                                          }}
                                        />
                                      )) ||
                                      (field.dataType === 13 && (
                                        <>
                                          <Form.Item
                                            initialValue={
                                              field.value
                                                ? field.value
                                                : undefined
                                            }
                                            name="contractexpirynumber"
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "Please add Contract expiry",
                                              },
                                            ]}
                                            style={{
                                              display: "inline-block",
                                              width: "calc(50% - 8px)",
                                              margin: "0px 0px 1px 0px ",
                                            }}
                                          >
                                            <InputNumber
                                              // value={contractexpiryvalue}
                                              min={1}
                                              onChange={(e) =>
                                                dispatch(
                                                  ObligationvalueaddedonChange({
                                                    fieldindex,
                                                    value: e,
                                                    contractType:
                                                      field?.contractType,
                                                    // enddate: item.fields,
                                                  })
                                                )
                                              }
                                              controls={false}
                                              //  value={1}
                                              addonBefore={
                                                <MinusOutlined
                                                  onClick={() => {
                                                    form.setFieldsValue({
                                                      [`contractexpirynumber`]:
                                                        form.getFieldValue(
                                                          "contractexpirynumber"
                                                        ) > 1
                                                          ? form.getFieldValue(
                                                              "contractexpirynumber"
                                                            ) - 1
                                                          : 1,
                                                    });
                                                    dispatch(
                                                      ObligationvalueaddedonChange(
                                                        {
                                                          fieldindex,
                                                          // enddate: item.fields,
                                                          contractType:
                                                            field?.contractType,
                                                          value:
                                                            form.getFieldValue(
                                                              "contractexpirynumber"
                                                            ) || 1,
                                                          field_id: field._id,
                                                        }
                                                      )
                                                    );
                                                  }}
                                                />
                                              }
                                              addonAfter={
                                                <PlusOutlined
                                                  onClick={() => {
                                                    form.setFieldsValue({
                                                      [`contractexpirynumber`]:
                                                        (form.getFieldValue(
                                                          "contractexpirynumber"
                                                        ) || 0) + 1,
                                                    });
                                                    dispatch(
                                                      ObligationvalueaddedonChange(
                                                        {
                                                          fieldindex,
                                                          // enddate: item.fields,
                                                          contractType:
                                                            field?.contractType,
                                                          value:
                                                            form.getFieldValue(
                                                              "contractexpirynumber"
                                                            ) || 1,
                                                          field_id: field._id,
                                                        }
                                                      )
                                                    );
                                                  }}
                                                />
                                              }
                                              placeholder={formatMessage({
                                                id: "enterdigit",
                                              })}
                                            />
                                          </Form.Item>
                                          <Form.Item
                                            initialValue={field?.contractType}
                                            name="contractType"
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "Please select Contract duration",
                                              },
                                            ]}
                                            style={{
                                              display: "inline-block",
                                              width: "calc(50% - 8px)",
                                              margin: "0px  0px 0px 15px ",
                                            }}
                                          >
                                            <Select
                                              optionFilterProp="children"
                                              showSearch
                                              getPopupContainer={(trigger) =>
                                                trigger.parentNode
                                              }
                                              showArrow
                                              placeholder={formatMessage({
                                                id: "select",
                                              })}
                                              onChange={(value) =>
                                                dispatch(
                                                  ObligationvalueaddedonChange({
                                                    fieldindex,
                                                    contractType: value,
                                                    value: field.value,
                                                    // enddate: item.fields,
                                                    field_id: field._id,
                                                  })
                                                )
                                              }
                                            >
                                              {selectexpirydata.map(
                                                (rt, index) => (
                                                  <Option
                                                    key={index}
                                                    value={rt.value}
                                                  >
                                                    {rt.name}
                                                  </Option>
                                                )
                                              )}
                                            </Select>
                                          </Form.Item>
                                        </>
                                      )) ||
                                      ([7, 15].includes(field.dataType) &&
                                        fieldindex === 0 && (
                                          <DatePicker
                                            disabledDate={(current) => {
                                              return (
                                                current &&
                                                current <
                                                  moment().startOf("day")
                                              );
                                            }}
                                            format="DD/MM/YYYY"
                                            onChange={(date) =>
                                              dispatch(
                                                ObligationvalueaddedonChange({
                                                  fieldindex,
                                                  value: date,
                                                  field_id: field._id,
                                                })
                                              )
                                            }
                                            placeholder={`Enter ${field.label}`}
                                            style={{ width: "100%" }}
                                          ></DatePicker>
                                        )) ||
                                      ([7, 15].includes(field.dataType) &&
                                        fieldindex !== 0 && (
                                          <DatePicker
                                            format="DD/MM/YYYY"
                                            onChange={(date) =>
                                              dispatch(
                                                ObligationvalueaddedonChange({
                                                  fieldindex,
                                                  value: date,
                                                  field_id: field._id,
                                                })
                                              )
                                            }
                                            placeholder={`Enter ${field.label}`}
                                            style={{ width: "100%" }}
                                          ></DatePicker>
                                        )) ||
                                      (field.dataType === 8 && (
                                        <Input
                                          placeholder={
                                            field.placeholder ||
                                            `Enter A ${field.label}`
                                          }
                                          size="middle"
                                          width={"100%"}
                                          onChange={(e) =>
                                            dispatch(
                                              ObligationvalueaddedonChange({
                                                fieldindex,
                                                value: e.target.value,
                                                field_id: field._id,
                                              })
                                            )
                                          }
                                        />
                                      )) ||
                                      (field.dataType === 3 && (
                                        <Radio.Group
                                          onChange={(e) =>
                                            dispatch(
                                              ObligationvalueaddedonChange({
                                                fieldindex,
                                                value: e.target.value,
                                                field_id: field._id,
                                              })
                                            )
                                          }
                                        >
                                          {field.options.map((item, index) => (
                                            <Radio key={index} value={item}>
                                              {item}
                                            </Radio>
                                          ))}
                                        </Radio.Group>
                                      )) ||
                                      (field.dataType === 5 && (
                                        <Checkbox.Group
                                          onChange={(checkedValues) =>
                                            dispatch(
                                              ObligationvalueaddedonChange({
                                                fieldindex,
                                                value: checkedValues,
                                                field_id: field._id,
                                              })
                                            )
                                          }
                                        >
                                          {field.options.map((item, index) => (
                                            <Checkbox key={index} value={item}>
                                              {item}
                                            </Checkbox>
                                          ))}
                                        </Checkbox.Group>
                                      )) ||
                                      (field.dataType === 6 &&
                                        field.typeOfOptions === "Single" && (
                                          <Select
                                            optionFilterProp="children"
                                            showSearch
                                            getPopupContainer={(trigger) =>
                                              trigger.parentNode
                                            }
                                            showArrow
                                            onChange={(value) =>
                                              dispatch(
                                                ObligationvalueaddedonChange({
                                                  fieldindex,
                                                  value: value,
                                                  field_id: field._id,
                                                })
                                              )
                                            }
                                            placeholder={`Enter ${field.label}`}
                                          >
                                            {field.options.map(
                                              (item, index) => (
                                                <Option key={item} value={item}>
                                                  {item}
                                                </Option>
                                              )
                                            )}
                                          </Select>
                                        )) ||
                                      (field.dataType === 6 &&
                                        field.typeOfOptions === "Multiple" && (
                                          <Select
                                            getPopupContainer={(trigger) =>
                                              trigger.parentNode
                                            }
                                            showArrow
                                            optionFilterProp="children"
                                            showSearch
                                            onChange={(value) =>
                                              dispatch(
                                                ObligationvalueaddedonChange({
                                                  fieldindex,
                                                  value: value,
                                                  field_id: field._id,
                                                })
                                              )
                                            }
                                            mode="multiple"
                                            allowClear
                                            placeholder={`Enter ${field.label}`}
                                          >
                                            {field.options.map(
                                              (item, index) => (
                                                <Option key={item} value={item}>
                                                  {item}
                                                </Option>
                                              )
                                            )}
                                          </Select>
                                        ))}
                                  </Form.Item>
                                </Col>
                                <Col span={1}></Col>
                                {field.infoRequired ? (
                                  <Col span={1}>
                                    <Tooltip
                                      title={
                                        field.info ||
                                        `Enter your ${field.label}`
                                      }
                                    >
                                      <InfoCircleOutlined
                                        style={{
                                          color: "#F99417",
                                          fontSize: "15px",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </Tooltip>
                                  </Col>
                                ) : null}
                              </Row>
                            </div>
                          )
                        )}

                        {!issubobligationformLoading &&
                          subObligationsformData?.obligationDocumentURL && (
                            <Form.Item
                              {...formItemLayout}
                              name="obligationDescription"
                              initialValue={
                                subObligationsformData.obligationDescription
                                  ? subObligationsformData.obligationDescription
                                  : ""
                              }
                              label={formatMessage({ id: "description" })}
                              rules={[
                                // { required: true, message: formatMessage({ id: "cname_rule" }) },
                                {
                                  whitespace: true,
                                  message: "Please enter description",
                                },
                              ]}
                            >
                              {console.log(
                                subObligationsformData.obligationDescription,
                                subObligationsformData,
                                "jkl"
                              )}
                              <Input.TextArea
                                defaultValue={
                                  subObligationsformData?.obligationDescription ||
                                  ""
                                }
                                placeholder={formatMessage({
                                  id: "plce_description",
                                })}
                              />
                            </Form.Item>
                          )}
                        {
                          <>
                            {!subObligationsformData?.obligationDocumentURL ? (
                              <>
                                <Divider orientation="left">
                                  Add documents
                                </Divider>
                                <Form.Item
                                  {...formItemLayout}
                                  name="obligationDescription"
                                  initialValue={
                                    subObligationsformData?.obligationDescription
                                      ? subObligationsformData?.obligationDescription
                                      : ""
                                  }
                                  label={formatMessage({ id: "description" })}
                                  rules={[
                                    // { required: true, message: formatMessage({ id: "cname_rule" }) },
                                    {
                                      whitespace: true,
                                      message:
                                        "Please enter a valid description",
                                    },
                                  ]}
                                >
                                  <Input.TextArea
                                  defaultValue={
                                  subObligationsformData?.obligationDescription ||
                                  ""
                                }
                                    placeholder={formatMessage({
                                      id: "plce_description",
                                    })}
                                  />
                                </Form.Item>
                                <Form.Item
                                  {...formItemLayout}
                                  name="Attachments"
                                  // initialValue={editRecord.obligationDescription ? editRecord.obligationDescription : ""}
                                  label={
                                    <b
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                      }}
                                    >
                                      Attachments
                                    </b>
                                  }
                                  rules={[
                                    {
                                      required: true,
                                      message: formatMessage({
                                        id: "attachment_rule",
                                      }),
                                    },
                                  ]}
                                >
                                  <Dragger {...propsforupload}>
                                    <p className="ant-upload-drag-icon">
                                      <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text">
                                      Click or drag file to this area to upload
                                    </p>
                                    <p className="ant-upload-hint">
                                      Supported file formats: PDF, PNG, JPG.
                                      Please upload a file in one of these
                                      formats.
                                    </p>
                                    {isAttachmentsubmitting && (
                                      <div className="obg-attachment-upload-progress">
                                        Uploading...
                                      </div>
                                    )}
                                  </Dragger>
                                </Form.Item>
                                {fileData?.name && (
                                  <div
                                    style={{
                                      border: "1px solid #d9d9d9",
                                      borderRadius: "4px",
                                      padding: "12px",
                                      background: "#f5f5f5",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div style={{ marginRight: "12px" }}>
                                        {getFileIcon(fileData.name)}
                                      </div>
                                      <div
                                        style={{ flex: 1, overflow: "hidden" }}
                                      >
                                        <Tooltip title={fileData.name}>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                            {displayFileName(fileData.name)}
                                          </div>
                                        </Tooltip>
                                        <div
                                          style={{
                                            color: "#888",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {fileData.size
                                            ? (fileData.size / 1024).toFixed(
                                                2
                                              ) + " KB"
                                            : ""}
                                        </div>
                                      </div>
                                      <Space>
                                        <Tooltip title="View">
                                          <Button
                                            type="text"
                                            icon={
                                              <EyeOutlined
                                                style={{
                                                  color: "blue",
                                                }}
                                              />
                                            }
                                            onClick={() => {
                                              dispatch(
                                                setViewAttachobgDocsdrawerVisible(
                                                  {
                                                    visible: true,
                                                    record:
                                                      AttachmentsubmittedData?.url,
                                                  }
                                                )
                                              );
                                            }}
                                          />
                                        </Tooltip>
                                        <Tooltip title="Delete">
                                          <Button
                                            type="text"
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={removeFile}
                                          />
                                        </Tooltip>
                                      </Space>
                                    </div>
                                  </div>
                                )}
                              </>
                            ) : (
                              <>
                                <Divider orientation="left">
                                  Attached Documents
                                </Divider>

                                <Row gutter={16}>
                                  <Col span={24}>
                                    <div
                                      onClick={() => {
                                        dispatch(
                                          setViewAttachobgDocsdrawerVisible({
                                            visible: true,
                                            record:
                                              subObligationsformData?.obligationDocumentURL,
                                          })
                                        );
                                      }}
                                      className={
                                        !isAttachedDocsVisible
                                          ? "obg-attach-parent"
                                          : "obg-attach-parent obg-attach-parent-selected"
                                      }
                                    >
                                      <div className="obg-attach-label">
                                        {subObligationsformData?.fileName}
                                      </div>
                                      <div>
                                        <Space>
                                          <EyeOutlined />
                                          {console.log(
                                            formfillforobligationrecord,
                                            formfillforobligationtype,
                                            "type"
                                          )}
                                          {subObligationsformData?.obligationStatus ===
                                            8 &&
                                            formfillforobligationtype !==
                                              "view" && (
                                              <DeleteOutlined
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  e.preventDefault();
                                                  dispatch(
                                                    DeleteUrlfromfile({
                                                      ...subObligationsformData,
                                                      obligationDocumentURL: "",
                                                    })
                                                  );
                                                }}
                                                style={{ color: "red" }}
                                              />
                                            )}
                                        </Space>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </>
                            )}
                          </>
                        }

                        <div className="action-buttons">
                          <Button icon={<SaveOutlined />}>Save as Draft</Button>
                          <Button
                            disabled={
                              formfillforobligationrecord?.obligationStatus ===
                              6
                                ? true
                                : isAttachmentsubmitting
                                ? true
                                : !isFormValid
                            }
                            type="primary"
                            htmlType="submit"
                            icon={<SendOutlined />}
                            loading={issubmitObligationdataLoading}
                            onClick={() => Submitobgligationsform(form)}
                          >
                            {loading ? "Submitting..." : "Submit Obligation"}
                          </Button>
                        </div>
                      </Form>
                    </Card>
                  </div>
                </div>
              </div>
            )}
        </>
      }
      {/* <Modal
        centered
        open={
          showSuccessModal || subObligationsformData?.obligationStatus === 6
        }
        onCancel={() => setShowSuccessModal(false)}
        footer={[
          <Button
            type="primary"
            key="close"
            onClick={() => setShowSuccessModal(false)}
          >
            Close
          </Button>,
        ]}
        title="Submission Successful!"
      >
        <div className="success-modal">
          <CheckCircleOutlined className="success-icon" />
          <p>
            Obligation <b>{subObligationsformData?.key}</b> has been submitted
            successfully.
          </p>
        </div>
      </Modal> */}
      {showSuccessModal && (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#f5f5f5",
          }}
        >
          <Card
            style={{
              maxWidth: 500,
              width: "100%",
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <Result
              status="success"
              title="Obligation Submitted Successfully"
              subTitle={
                <p>
                  Obligation <b>{subObligationsformData?.key}</b> has been
                  submitted successfully.
                </p>
              }
            />
          </Card>
        </div>
      )}
      {dataForFillObligation?.message === "Link expired" && (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#f5f5f5",
          }}
        >
          <Card
            style={{
              maxWidth: 500,
              width: "100%",
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <Result
              status="error"
              title="Email Link Invalid"
              subTitle="The link you used has expired or is no longer valid. Please request a new email link to continue."
              //   extra={[
              //     <Button type="primary" key="request">
              //       Request New Link
              //     </Button>,
              //     <Button key="back" onClick={() => window.location.href = "/"}>
              //       Back to Home
              //     </Button>,
              //   ]}
            />
          </Card>
        </div>
      )}
      {dataForFillObligation?.message ===
        "This obligation already submitted" && (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#f5f5f5",
          }}
        >
          <Card
            style={{
              maxWidth: 500,
              width: "100%",
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <Result
              status="info"
              title="Action Already Taken"
              subTitle="This obligation has already been processed. No further action is required."
            />
          </Card>
        </div>
      )}
      {(issubobligationformLoading || isValidatingTokenForFillObligation) && (
        <>
          <div
            style={{
              height: "90vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        </>
      )}
      {dataForFillObligation?.message === "Obligation Completed Action" &&
        !isAcceptorRejectSubmitted &&
        !isValidatingTokenForFillObligation && (
          <>
            <div
              style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#f5f5f5",
              }}
            >
              <Card
                style={{
                  maxWidth: 600,
                  width: "100%",
                  borderRadius: 12,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
              >
                <Result
                  status="info"
                  title="Obligation"
                  subTitle="Please review the obligation details below and accept or reject it."
                />

                {/* Obligation Details */}
                <Descriptions
                  bordered
                  size="middle"
                  column={1}
                  style={{ marginBottom: 24 }}
                >
                  <Descriptions.Item label="Obligation ID">
                    {subObligationsformData?.key || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Name">
                    {subObligationsformData?.obligationName || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Due Date">
                    {dateTimeFormatter(
                      subObligationsformData?.obligationDueDate
                    ) || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Description">
                    {subObligationsformData?.obligationDescription ||
                      "No description available"}
                  </Descriptions.Item>
                </Descriptions>

                {/* Action Buttons */}
                <Space style={{ display: "flex", justifyContent: "center" }}>
                  {/* ✅ Accept button with confirmation */}
                  <Button
                    loading={isacceptorrejectedLoading}
                    type="primary"
                    onClick={() => {
                      confirm({
                        title:
                          "Are you sure you want to Accept this Obligation?",
                        icon: <ExclamationCircleOutlined />,
                        okText: "Yes, Accept",
                        cancelText: "Cancel",
                        onOk: () => {
                          const data = {
                            obligationId: subObligationsformData._id,
                            obligationStatus: 7,
                            notCallRest: true,
                          };
                          const obgpageSubobligationData = {
                            ...MySubObligationPagination,
                            parentObligationId: subObligationsformData?._id,
                            obligationFor:
                              subObligationsformData?.obligationFor,
                            taskId: subObligationsformData?.taskId,
                          };
                          return dispatch(
                            getAcceptorrejectobligation({
                              data,
                              obgpageSubobligationData,
                              contractId: subObligationsformData?._id,
                            })
                          );
                        },
                      });
                    }}
                  >
                    Accept
                  </Button>

                  {/* ❌ Reject button with confirmation */}
                  <Button
                    danger
                    onClick={() => {
                      const data = {
                        obligationId: subObligationsformData._id,
                        obligationStatus: 8,
                        notCallRest: true,
                      };
                      const obgpageSubobligationData = {
                        ...MySubObligationPagination,
                        parentObligationId: subObligationsformData?._id,
                        obligationFor: subObligationsformData?.obligationFor,
                        taskId: subObligationsformData?.taskId,
                      };
                      dispatch(
                        setobligationRejectmodalVisible({
                          visible: true,
                          record: { data, obgpageSubobligationData },
                        })
                      );
                    }}
                  >
                    Reject
                  </Button>
                </Space>
              </Card>
              {isobligationrejectmodalVisible && (
                <Rejectobligationmodal {...props} />
              )}
              {}
            </div>
          </>
        )}
      <ObligationStatusMessage
        isAcceptorRejectSubmitted={isAcceptorRejectSubmitted}
        isAcceptorRejectStatus={isAcceptorRejectStatus}
      />
      {isAttachedDocsVisible && <ViewAttachobgDocsdrawer {...props} />}
    </div>
  );
};

export default connect((state) => ({
  Obligation: state.Obligation,
  MyObligation: state.MyObligation,
  myContract: state.myContract,
}))(injectIntl(ObligationFormAntd));
